import { Model } from "backbone"

class AuthorCommunication extends Model {}

AuthorCommunication.prototype.urlRoot = "/author_communications"

export default AuthorCommunication
